// Sample CSV template for the bulk short-link generator.
// Header columns must match the backend contract exactly and in this order.
export const SAMPLE_CSV =
  'path,utm_source,utm_medium,utm_campaign,utm_content,utm_term,prefix,short_url_tag,description,expire_at\n' +
  'welcome,facebook,cpc,summer_launch,ad_variant_1,yoga,camp,summer2026,Landing page for summer campaign,2026-12-31\n';

// downloadSampleCSV builds an in-memory CSV blob and triggers a browser download,
// with no backend round-trip (Blob + anchor pattern).
export function downloadSampleCSV() {
  const blob = new Blob([SAMPLE_CSV], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = 'bulk_short_links_sample.csv';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
